import { z } from "zod";

const optional = () => z.string().optional().or(z.literal(""));

export const locationFormSchema = z.object({
  code: z
    .string()
    .trim()
    .min(1, "Code is required")
    .max(20)
    .regex(/^[A-Za-z0-9_-]+$/, "Use letters, numbers, - or _"),
  name: z.string().trim().min(1, "Name is required").max(100),
  location_type: z.enum(["yard", "shed", "bay", "bin", "floor", "other"]),
  parent_id: optional(),
  description: optional(),
  is_active: z.boolean(),
  sort_order: z.coerce.number().int(),
});

export type LocationFormValues = z.infer<typeof locationFormSchema>;

export const emptyLocationForm: LocationFormValues = {
  code: "",
  name: "",
  location_type: "shed",
  parent_id: "",
  description: "",
  is_active: true,
  sort_order: 0,
};
